<template>
  <div class="main-container">
    <div class="add-role-title">
      <i class="line"></i>
      <span class="title-text" v-if="isAuth == '1'">角色信息</span>
      <span class="title-text" v-else>新增角色</span>
    </div>

    <Form ref="formInline" class="page-form four" :label-width="80" :model="formData">
      <FormItem label="角色名称" prop="name" :rules="$units.formRule.required('请输入角色名称')" class="four" v-if="isAuth != '1'" style="width: 500px">
        <Input v-model="formData.name" placeholder="请输入" clearable />
      </FormItem>

      <FormItem label="适用机构" prop="roleType" :rules="$units.formRule.required('请选择机构')" class="four" style="width: 450px">
        <RadioGroup v-model="formData.roleType" @on-change="changeRadio">
          <Radio :label="item.label" :disabled="isAuth == '1'" v-for="(item, index) in orgList" :key="index">{{ item.name }}</Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="" prop="roleOrganIds" class="four" :label-width="0" style="width: 250px" :rules="$units.formRule.arrRequired('请选择机构', 'change')">
        <Select v-model="formData.roleOrganIds" :disabled="isCurrentRoles" :multiple="true" filterable>
          <Option v-for="item in organList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>

      <FormItem prop="isSyncNew" label :rules="$units.formRule.required('是否自动同步新菜单')" :label-width="150" style="width: 300px">
        <span slot="label" class="label"
          >自动同步新菜单<span class="tip-icon">?</span>
          <div class="pop-tip">
            <span>选是：系统有新菜单时自动勾选</span>
            <span>选否：系统有新菜单时不勾选</span>
            <div class="arrow"></div>
          </div>
        </span>

        <RadioGroup v-model="formData.isSyncNew" :disabled="isCurrentRoles" style="margin-top: 2px">
          <Radio label="1" :disabled="isCurrentRoles">是</Radio>
          <Radio label="0" :disabled="isCurrentRoles">否</Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="备注" class="full" v-if="isAuth != '1'">
        <Input v-model="formData.remark" placeholder="请输入" clearable />
      </FormItem>
    </Form>

    <div class="add-role-title spacing">
      <i class="line"></i>
      <span class="title-text">菜单权限</span>
      <div class="text-1">查看：是否展示菜单给此角色</div>
      <div class="text-2">查看敏感数据：是否展示完整信息（姓名、手机号、证件号、地址、邮箱）给此角色</div>
    </div>

    <loading :isShow="$root.$children[0].isShowLoading" />
    <div class="page-body">
      <div class="table-page">
        <div class="rate-table">
          <div class="head">
            <div class="td first-td td-p">
              <div class="name-key">一级菜单</div>
            </div>
            <div class="td td-p">二级菜单</div>
            <div class="td td-p">三级菜单</div>
            <div class="td last-td td-p">功能点</div>
          </div>

          <div class="body">
            <div class="empty-text" v-if="tableData.length == 0">暂无数据</div>

            <div class="row-child" v-for="(item, x) in tableData" :key="x">
              <div class="head">
                <div class="td">
                  <span class="name-key-01">
                    <div class="seat-dom"></div>
                    <Checkbox
                      :disabled="isCurrentRoles"
                      :true-value="1"
                      :false-value="0"
                      v-model="item.isExist"
                      @on-change="changeCheckBox(item, x, tableData)"
                      >{{ item.name }}</Checkbox
                    >
                  </span>

                  <div class="td-2-box">
                    <div v-for="(item2, x2) in item.childs" :key="x2" class="td-2" :class="item.childs.length == x2 + 1 ? 'no-data' : ''">
                      <span class="name-key-02">
                        <Checkbox
                         
                          :disabled="isCurrentRoles"
                          v-if="!item2.web && item2.name"
                         
                          :true-value="1"
                         
                          :false-value="0"
                         
                          v-model="item2.isExist"
                         
                          @on-change="changeCheckBox(item2, x2, tableData)"
                          
                          >{{ item2.name }}</Checkbox
                        
                        >
                      </span>

                      <div class="td-3-box">
                        <div v-for="(item3, x3) in item2.childs" :key="x3" class="td-3" :class="item2.childs.length == x3 + 1 ? 'no-data' : ''">
                          <span class="name-key-03">
                            <Checkbox
                             
                              :disabled="isCurrentRoles"
                              v-if="!item3.web && item3.name"
                             
                              :true-value="1"
                             
                              :false-value="0"
                             
                              v-model="item3.isExist"
                             
                              @on-change="changeCheckBox(item3, x3, tableData)"
                              
                              >{{ item3.name }}</Checkbox
                            
                            >
                          </span>
                          <div class="td-4-box" v-if="item2.perms">
                            <div v-for="(item4, x4) in item2.perms" :key="x4" class="td-4">
                              <span
                                class="name-key-04"
                                :class="{ 'see-2': item4.name == '查看', 'see-1': item4.name == '查看敏感数据' || item4.isSensitive == '1' }"
                              >
                                <Checkbox
                                  v-if="!item4.web"
                                  :disabled="item4.name == '查看' || isCurrentRoles"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item4.isExist"
                                  @on-change="changeCheckBox(item4, x4, tableData)"
                                >
                                  {{ item4.name }}
                                </Checkbox>
                              </span>
                            </div>
                          </div>
                          <div class="td-4-box" v-else>
                            <div v-for="(item4, x4) in item3.perms" :key="x4" class="td-4">
                              <span
                                class="name-key-04"
                                :class="{ 'see-2': item4.name == '查看', 'see-1': item4.name == '查看敏感数据' || item4.isSensitive == '1' }"
                              >
                                <Checkbox
                                  v-if="!item4.web"
                                  :disabled="item4.name == '查看' || isCurrentRoles"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item4.isExist"
                                  @on-change="changeCheckBox(item4, x4, tableData)"
                                >
                                  {{ item4.name }}
                                </Checkbox>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="td-3-box" v-if="!item2.childs.length">
                        <div class="td-3 no-data">
                          <span class="name-key-03"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="seize-dom"></div>
    <div class="action-footer" v-if="!isCurrentRoles">
      <div class="btn-box" v-if="!isCurrentRoles">
        <Button class="btn-cancel" @click="close">取消</Button>
        <Button class="btn-save" @click="save" :loading="loading">保存</Button>
      </div>
    </div>
  </div>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
import { common } from '@/api/mixins';
export default {
  components: { selectTree },
  mixins: [common],
  data() {
    return {
      formData: {
        roleType: ''
      },
      tableData: [],
      organList: [], //适用机构
      menuIds: [],
      permIds: [],
      id: '',
      isCopy: null, //复制(1：是，0：否)
      isAuth: null, //权限修改(1：是，0：否)
      orgList: [],
      loading: false,
      userInfo: {},
      isCurrentRoles: false
    };
  },

  created() {
    this.userInfo = JSON.parse(localStorage.userInfo);
    this.isCopy = this.$route.query.isCopy;
    this.isAuth = this.$route.query.isAuth;
    this.isCurrentRoles = this.$route.query.isCurrentRoles == '1';
    this.id = this.$route.query.id;
    if (!this.id) {
      this.formData.roleOrganIds = [this.userInfo.organId];
    }
    this.queryOrgList();
    this.queryFormDetail();
    setTimeout(() => {
      this.orgDataSet();
      this.queryData();
    }, 500);
  },

  methods: {
    orgDataSet() {
      const orgType = !this.id ? JSON.parse(localStorage.userInfo).orgType : this.formData.roleType;
      // 新增角色
      if (!this.id) {
        if (orgType == 1) {
          this.formData.roleType = '1';
          // 商户
          this.orgList = [
            {
              label: '1',
              name: '本机构'
            },
            {
              label: '2',
              name: '省级机构'
            },
            {
              label: '3',
              name: '市级机构'
            },
            {
              label: '4',
              name: '区级机构'
            },
            {
              label: '6',
              name: '营业部'
            }
          ];
        } else if (orgType == 2) {
          this.formData.roleType = '2';
          // 省级
          this.orgList = [
            {
              label: '2',
              name: '省级机构'
            },
            {
              label: '3',
              name: '市级机构'
            },
            {
              label: '4',
              name: '区级机构'
            },
            {
              label: '6',
              name: '营业部'
            }
          ];
        } else if (orgType == 3) {
          this.formData.roleType = '3';
          // 市级
          this.orgList = [
            {
              label: '3',
              name: '市级机构'
            },
            {
              label: '4',
              name: '区级机构'
            },
            {
              label: '6',
              name: '营业部'
            }
          ];
        } else if (orgType == 4) {
          this.formData.roleType = '4';
          // 区级
          this.orgList = [
            {
              label: '4',
              name: '区级机构'
            },
            {
              label: '6',
              name: '营业部'
            }
          ];
        } else if (orgType == 6) {
          this.formData.roleType = '6';
          // 营业部
          this.orgList = [
            {
              label: '6',
              name: '营业部'
            }
          ];
        }
      } else {
        if (orgType == 1) {
          // 查看权限
          this.orgList = [
            {
              label: '1',
              name: '本机构'
            },
            {
              label: '2',
              name: '省级机构'
            },
            {
              label: '3',
              name: '市级机构'
            },
            {
              label: '4',
              name: '区级机构'
            },
            {
              label: '6',
              name: '营业部'
            }
          ];
        } else {
          // 查看权限
          this.orgList = [
            {
              label: '2',
              name: '省级机构'
            },
            {
              label: '3',
              name: '市级机构'
            },
            {
              label: '4',
              name: '区级机构'
            },
            {
              label: '6',
              name: '营业部'
            }
          ];
        }
      }
    },

    // 查询适用机构
    queryOrgList() {
      const orgType = JSON.parse(localStorage.userInfo).orgType;
      let data = {
        pageSize: 999
      };
      if (this.formData.roleType == 1) {
        data.orgTypes = [orgType];
      } else {
        data.orgTypes = [this.formData.roleType];
      }
      return this.$http({
        url: '/buz/organizationBase/read/list',
        type: 'POST',
        data
      }).then(res => {
        this.organList = res.data;
      });
    },

    queryData() {
      this.$http({
        url: '/buz/rolesExt/menuPerms',
        type: 'POST',
        data: {
          menuType: '2',
          isUpdate: '1',
          roleType: this.formData.roleType,
          roleIds: this.isCopy || this.isAuth ? this.id.split(',') : ''
        }
      }).then(res => {
        this.tableData = this.configData(res.data);
        this.$root.$children[0].isShowLoading = false;
      });
    },

    // 切换适用机构
    async changeRadio(data) {
      this.menuIds = [];
      this.permIds = [];
      this.formData.roleOrganIds = [];
      await this.queryOrgList();
      this.queryData();
      if (data == this.userInfo.orgType) {
        this.formData.roleOrganIds = [JSON.parse(localStorage.userInfo).organId];
      }
    },

    queryFormDetail() {
      let userInfo = JSON.parse(localStorage.userInfo);
      this.$http({
        url: '/buz/rolesExt/queryDetail',
        type: 'GET',
        data: {
          id: this.id
        }
      }).then(res => {
        this.formData.roleOrganIds = [];
        this.formData = {
          name: this.isCopy == 1 ? '' : res.data && res.data.name,
          isSyncNew: res.data && res.data.isSyncNew,
          roleOrganIds: !this.id ? [userInfo.organId] : res.data && res.data.organIds,
          remark: this.isCopy == 1 ? '' : ''
        };
        if (this.id) {
          this.$set(this.formData, 'roleType', res.data.roleType.toString());
        } else {
          this.$set(this.formData, 'roleType', userInfo.orgType);
        }
        this.queryOrgList();
      });
    },

    // 回显
    configData(arr) {
      // 第一级菜单
      arr.map((item2, index2) => {
        // 处理二级菜单
        if (!item2.childs.length) {
          item2.childs = [
            {
              id: item2.id,
              level: 2,
              name: '-',
              childs: [],
              web: true
            }
          ];
        }
        item2.isExist = this.id && !item2.isExist ? 0 : 1;
        if (this.id && item2.isExist == 1 && !item2.web) {
          this.menuIds.push(item2.id);
        } else if (!this.id && !item2.web) {
          this.menuIds.push(item2.id);
        }

        // 处理三级菜单
        item2.childs.map((item3, index3) => {
          // 处理二级菜单
          if (!item3.childs.length) {
            item3.childs = [
              {
                id: item3.id,
                level: 3,
                name: '-',
                childs: [],
                web: true
              }
            ];
          }

          // 回显二级菜单
          item3.isExist = this.id && !item3.isExist ? 0 : 1;
          if (this.id && item3.isExist == 1 && !item3.web) {
            this.menuIds.push(item3.id);
          } else if (!this.id && !item3.web) {
            this.menuIds.push(item3.id);
          }

          item3.childs.map(item4 => {
            item4.childs = item3.perms || item4.perms || [];
            // 回显三级菜单
            item4.isExist = this.id && !item4.isExist ? 0 : 1;
            if (this.id && item4.isExist == 1 && !item4.web) {
              this.menuIds.push(item4.id);
            } else if (!this.id && !item4.web) {
              this.menuIds.push(item4.id);
            }

            item4.childs.map(item5 => {
              // 回显功能点
              item5.isExist = (!this.id && item5.name != '搜索/查看/导出供应商') || item5.isExist ? 1 : 0;
              if (this.id && item5.isExist == 1) {
                this.permIds.push(item5.id);
              } else if (!this.id && item5.name != '搜索/查看/导出供应商') {
                this.permIds.push(item5.id);
              }
            });
          });
        });
      });
      return arr;
    },

    // 选中/取消节点
    changeCheckBox(row, index, tableData) {
      if (row.level == 1) {
        this.arrPush(row, row.id);
        // 勾选-处理一级级菜单联动父级交互，选中功能点，联动所有父级进行
        this.selectUpNode(row, tableData);
        // 取消-处理一级级菜单下所有节点取消勾选
        if (row.isExist == 0) {
          this.checkNode(row, tableData, 0);
        } else {
          this.checkNode(row, tableData, 1);
        }
      } else if (row.level == 2) {
        this.arrPush(row, row.id);
        // 勾选-处理二级级菜单联动父级交互，选中功能点，联动所有父级进行
        this.selectUpNode(row, tableData);
        // 取消-处理二级级菜单下所有节点取消勾选
        if (row.isExist == 0) {
          this.checkNode(row, tableData, 0);
        } else {
          this.checkNode(row, tableData, 1);
        }
      } else if (row.level == 3) {
        this.arrPush(row, row.id);
        // 处理三级菜单联动父级交互，选中功能点，联动所有父级进行勾选
        this.selectUpNode(row, tableData);
        // 取消-处理三级菜单下所有节点取消勾选
        if (row.isExist == 0) {
          this.checkNode(row, tableData, 0);
        } else {
          this.checkNode(row, tableData, 1);
        }
      } else {
        this.arrPush(row, row.id);
        // 处理功能点联动父级交互，选中功能点，联动所有父级进行勾选
        this.selectUpNode(row, tableData);
        // 选中功能点勾选上查看节点
        if (row.isExist == 1) {
          let arr = this.getBrotherNodes(tableData, row.id);
          // 获取查看的id
          let seeIdFilter = arr.filter(item => item.name == '查看');
          if (seeIdFilter.length) {
            let seeId = arr.filter(item => item.name == '查看')[0].id;
            this.checkSeeNode(tableData, seeId);
          }
        }
      }
    },

    // 根据id数组值，选中父节点
    setSelectParentNode(list, allParentIds) {
      list.forEach(item => {
        if (allParentIds.includes(item.id) && item.childs) {
          // 当前父级未被选中则选中，收集不属于接口数据给的节点id放入
          if (item.isExist != '1' && !item.web) {
            item.isExist = 1;
            this.arrPush(item, item.id);
          }
          this.setSelectParentNode(item.childs, allParentIds);
        }
      });
    },

    // 根据id，进行子节点取消
    cancelChildNode(list, allChildIds) {
      list.forEach(item => {
        // 当前子节点已被选中进行取消掉，收集不属于接口数据给的节点id放入
        if (allChildIds.includes(item.id) && item.isExist == '1' && !item.web) {
          item.isExist = 0;
          this.arrPush(item, item.id);
        }
        item.childs && this.cancelChildNode(item.childs, allChildIds);
      });
    },

    // 根据id，进行子节点选中
    checkChildNode(list, allChildIds) {
      list.forEach(item => {
        // 当前子节点已被选中进行取消掉，收集不属于接口数据给的节点id放入
        if (allChildIds.includes(item.id) && item.isExist == '0' && !item.web) {
          item.isExist = 1;
          this.arrPush(item, item.id);
        }
        item.childs && this.checkChildNode(item.childs, allChildIds);
      });
    },

    // 修改查看节点进行选中
    checkSeeNode(list, seeId) {
      list.forEach(item => {
        if (item.id == seeId && item.isExist == '0' && !item.web) {
          item.isExist = 1;
          this.arrPush(item, item.id);
        }
        item.childs && this.checkSeeNode(item.childs, seeId);
      });
    },

    // 查找所有父节点
    getParentsById(list, id) {
      for (let i in list) {
        if (list[i].id == id) {
          //查询到就返回该数组对象
          return [list[i]];
        }
        if (list[i].childs) {
          let node = this.getParentsById(list[i].childs, id);
          if (node !== undefined) {
            //查询到把父节点连起来
            return node.concat(list[i]);
          }
        }
      }
    },

    // 查找所有子节点
    getchildById(list, newNodeId = []) {
      for (let i in list) {
        newNodeId.push(list[i]);
        if (list[i].childs) {
          this.getchildById(list[i].childs, newNodeId);
        }
      }
      return newNodeId;
    },

    // 查找兄弟节点
    getBrotherNodes(list, id) {
      for (let i in list) {
        if (list[i].id == id) {
          return list.filter(v => v.id != id);
        }
        if (list[i].childs?.length > 0) {
          let node = this.getBrotherNodes(list[i].childs, id);
          if (node) return node.filter(v => v.id != id);
        }
      }
    },

    // 向上进行勾选
    selectUpNode(row, tableData) {
      if (row.isExist == 1) {
        // 获取当前节点所有父级id
        let allParentIds = this.getParentsById(tableData, row.id).map(item => item.id);
        this.setSelectParentNode(tableData, allParentIds);
      }
    },

    // 向上/向下-取消/选中
    checkNode(row, tableData, status) {
      if (row.childs && row.childs.length) {
        // 获取当前节点所有子级id
        let allchildIds = this.getchildById(row.childs).map(item => item.id);
        if (status == 0) {
          this.cancelChildNode(tableData, allchildIds);
        } else {
          this.checkChildNode(tableData, allchildIds);
        }
      }
    },

    // 功能点、菜单参数id进行删除添加
    arrPush(row, id) {
      // 菜单
      if (row.level == 1 || row.level == 2 || row.level == 3) {
        if (this.menuIds.includes(id)) {
          // 已选中则删除掉
          let index = this.menuIds.indexOf(id);
          this.menuIds.splice(index, 1);
        } else {
          // 没有则往数组中添加
          this.menuIds.push(id);
        }
      } else {
        // 功能点
        if (this.permIds.includes(id)) {
          // 已选中则删除掉
          let index = this.permIds.indexOf(id);
          this.permIds.splice(index, 1);
        } else {
          // 没有则往数组中添加
          this.permIds.push(id);
        }
      }
    },

    // 关闭当前页面
    close() {
      this.back(this.$route.query.backUrl || '/systemSet/roleManage');
    },

    save() {
      this.$refs['formInline'].validate(valid => {
        if (valid) {
          let data = {
            ...this.formData,
            menuIds: this.menuIds,
            permIds: this.permIds
          };
          Object.keys(data).forEach(item => {
            if (!data[item]) delete data[item];
          });

          if (this.isAuth == '1') {
            data.id = this.id;
          }
          this.loading = true;
          this.$http({
            url: this.isAuth != '1' ? '/buz/rolesExt/save' : '/buz/rolesExt/update',
            type: 'POST',
            data,
            apiPermissionCode: 'org_5_2'
          })
            .then(res => {
              this.$notice.success('保存成功');
              this.close();
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          document.documentElement.scrollTop = 0;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import './changeRoleForm.scss';
</style>